// 体育行业
import { getPartitioningChild } from '@/utils/api'

export default {
  state: {
    // 体育市场采购细分列表
    sportsMarketList: [],
    // 政府机关采购细分列表
    governmentMarketList: [],
    // 地区采购规模市场划分选中的类型 1：细分市场 2：政府机关采购细分 3：体育市场采购细分
    regionRadioValue: 1,
  },
  getters: {},
  mutations: {
    // 设置体育市场采购细分列表
    setSportsMarketList(state, data) {
      state.sportsMarketList = [...data]
    },
    // 设置政府机关采购细分列表
    setGovernmentMarketList(state, data) {
      state.governmentMarketList = [...data]
    },
  },
  actions: {
    // 获取体育市场采购细分列表
    async getSportsMarketList({ commit }) {
      let [err, res] = await getPartitioningChild(9)
      if (err) return
      // 保存车型列表
      commit('setSportsMarketList', res)
    },
    // 获取政府机关采购细分列表
    async getGovernmentMarketList({ commit }) {
      let [err, res] = await getPartitioningChild(10)
      if (err) return
      // 保存车型列表
      commit('setGovernmentMarketList', res)
    },
  }
}
